// Meta Pixel ("Restora website"). It tells Facebook which ad clicks became
// sign-ups. The loader is in index.html; this is the one place the app talks
// to it.

// Report an event to Facebook. Does nothing if the loader was blocked (ad
// blockers remove it), so callers never need to check.
export function trackPixel(event, params) {
  if (typeof window.fbq === 'function') window.fbq('track', event, params)
}
